import type { ReactNode } from "react";

export type IncrementerButtonProperties = {
  label: string;
  children: ReactNode;
  onClick: () => void;
  isDisabled?: boolean | undefined;
  minimum?: number | undefined;
  maximum?: number | undefined;
};
export const IncrementerButton = ({
  label,
  children,
  onClick,
  isDisabled,
}: IncrementerButtonProperties) => (
  <button
    aria-label={label}
    className="cursor-pointer rounded-full border border-primary text-primary outline-0 transition-colors hover:border-state-primary-hover hover:bg-state-primary-hover hover:text-on-primary focus-visible:border-primary-variant focus-visible:bg-primary-variant focus-visible:text-on-primary disabled:border-disabled-variant disabled:text-disabled-variant disabled:hover:bg-transparent"
    disabled={isDisabled}
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
);
IncrementerButton.displayName = "Incrementer.Button";
